// @ts-nocheck
export default defineNuxtRouteMiddleware((to, from) => {
  // // to.meta.keepalive = false
  // if (import.meta.client) {
  //   to.meta.keepalive = true
  //   from.meta.keepalive = true
  // } else {
  //   to.meta.keepalive = false
  //   from.meta.keepalive = false
  // }
})
